import {DEFAULT_ZOOM} from '@src/constants';
import {
  ParserMap,
  UseQueryStatesOptions,
  createParser,
  createSerializer,
  parseAsArrayOf,
  useQueryStates,
} from 'nuqs';
import {useCallback} from 'react';
import {QUERY_PARAM_REGISTRY} from './registry.ts';

export const geoCoordParser = createParser({
  parse: queryValue => parseFloat(queryValue),
  serialize: v => v.toFixed(5),
});

export const zoomParser = createParser({
  parse: queryValue => parseFloat(queryValue),
  serialize: v => v.toFixed(2),
});

const parsersMap = {
  zoom: zoomParser.withDefault(DEFAULT_ZOOM),
  center: parseAsArrayOf(geoCoordParser).withDefault([0, 0]),
} as ParserMap;

const options = {
  shallow: false,
  urlKeys: {
    zoom: QUERY_PARAM_REGISTRY.zoom,
    center: QUERY_PARAM_REGISTRY.center,
  },
} as Partial<UseQueryStatesOptions<typeof parsersMap>>;

export const serialize = createSerializer(parsersMap, options);

const useMapLocationParams = () => {
  const [{zoom, center}, setMapLocationParams] = useQueryStates(
    parsersMap,
    options,
  );

  const resetMapLocationParams = useCallback(() => {
    setMapLocationParams(null);
  }, [setMapLocationParams]);

  return {
    center,
    resetMapLocationParams,
    serialize,
    setMapLocationParams,
    zoom,
  };
};

export default useMapLocationParams;
